import script from "./ClusterBadgeIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClusterBadgeIcon.vue?vue&type=script&setup=true&lang=ts"

import "./ClusterBadgeIcon.vue?vue&type=style&index=0&id=f311a8ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f311a8ea"]])

export default __exports__